(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["algodones-carro-lateral"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__algCarroLateral) return;
    window.__algCarroLateral = true;

    var SECCION = 'cart-drawer-section';
    var CLAVES_FACT = ['razon-social_fact', 'rut_fact', 'giro_fact', 'direccion_fact', 'region_fact', 'comuna_fact', 'fono_fact', 'email_fact'];
    var ATTR_REGALO_VACIOS = { 'gift-wrapping': '', 'gift-mode': '', 'gift-wrap-qty': '', 'gift-to': '', 'gift-from': '', 'gift-note': '' };

    /* Las comunas por región, las mismas del selector del Wokiee (y de algodones-factura). */
    var COMUNAS = {
      AN: ["Antofagasta","Calama","María Elena","Mejillones","Ollagüe","San Pedro de Atacama","Sierra Gorda","Taltal","Tocopilla"],
      AR: ["Angol","Carahue","Cholchol","Collipulli","Cunco","Curacautín","Curarrehue","Ercilla","Freire","Galvarino","Gorbea","Lautaro","Loncoche","Lonquimay","Los Sauces","Lumaco","Melipeuco","Nueva Imperial","Padre las Casas","Perquenco","Pitrufquén","Pucón","Purén","Renaico","Saavedra","Temuco","Teodoro Schmidt","Toltén","Traiguén","Victoria","Vilcún","Villarrica"],
      AP: ["Arica","Camarones","General Lagos","Putre"],
      AT: ["Alto del Carmen","Caldera","Chañaral","Copiapó","Diego de Almagro","Freirina","Huasco","Tierra Amarilla","Vallenar"],
      AI: ["Aisén","Chile Chico","Cisnes","Cochrane","Coihaique","Guaitecas","Lago Verde","O’Higgins","Río Ibáñez","Tortel"],
      BI: ["Alto Biobío","Antuco","Arauco","Cabrero","Cañete","Chiguayante","Concepción","Contulmo","Coronel","Curanilahue","Florida","Hualpén","Hualqui","Laja","Lebu","Los Álamos","Los Ángeles","Lota","Mulchén","Nacimiento","Negrete","Penco","Quilaco","Quilleco","San Pedro de la Paz","San Rosendo","Santa Bárbara","Santa Juana","Talcahuano","Tirúa","Tomé","Tucapel","Yumbel"],
      CO: ["Andacollo","Canela","Combarbalá","Coquimbo","Illapel","La Higuera","La Serena","Los Vilos","Monte Patria","Ovalle","Paihuano","Punitaqui","Río Hurtado","Salamanca","Vicuña"],
      LL: ["Ancud","Calbuco","Castro","Chaitén","Chonchi","Cochamó","Curaco de Vélez","Dalcahue","Fresia","Frutillar","Futaleufú","Hualaihué","Llanquihue","Los Muermos","Maullín","Osorno","Palena","Puerto Montt","Puerto Octay","Puerto Varas","Puqueldón","Purranque","Puyehue","Queilén","Quellón","Quemchi","Quinchao","Río Negro","San Juan de la Costa","San Pablo"],
      LR: ["Corral","Futrono","La Unión","Lago Ranco","Lanco","Los Lagos","Mariquina","Máfil","Paillaco","Panguipulli","Río Bueno","Valdivia"],
      MA: ["Antártica","Cabo de Hornos (Ex Navarino)","Laguna Blanca","Natales","Porvenir","Primavera","Punta Arenas","Río Verde","San Gregorio","Timaukel","Torres del Paine"],
      ML: ["Cauquenes","Chanco","Colbún","Constitución","Curepto","Curicó","Empedrado","Hualañé","Licantén","Linares","Longaví","Maule","Molina","Parral","Pelarco","Pelluhue","Pencahue","Rauco","Retiro","Romeral","Río Claro","Sagrada Familia","San Clemente","San Javier","San Rafael","Talca","Teno","Vichuquén","Villa Alegre","Yerbas Buenas"],
      NB: ["Bulnes","Chillán","Chillán Viejo","Cobquecura","Coelemu","Coihueco","El Carmen","Ninhue","Pemuco","Pinto","Portezuelo","Quillón","Quirihue","Ránquil","San Carlos","San Fabián","San Ignacio","San Nicolás","Treguaco","Yungay","Ñiquén"],
      LI: ["Chimbarongo","Chépica","Codegua","Coinco","Coltauco","Doñihue","Graneros","La Estrella","Las Cabras","Litueche","Lolol","Machalí","Malloa","Marchihue","Mostazal","Nancagua","Navidad","Olivar","Palmilla","Paredones","Peralillo","Peumo","Pichidegua","Pichilemu","Placilla","Pumanque","Quinta de Tilcoco","Rancagua","Rengo","Requínoa","San Fernando","San Vicente","Santa Cruz"],
      RM: ["Alhué","Buin","Calera de Tango","Cerrillos","Cerro Navia","Colina","Conchalí","Curacaví","El Bosque","El Monte","Estación Central","Huechuraba","Independencia","Isla de Maipo","La Cisterna","La Florida","La Granja","La Pintana","La Reina","Lampa","Las Condes","Lo Barnechea","Lo Espejo","Lo Prado","Macul","Maipú","María Pinto","Melipilla","Padre Hurtado","Paine","Pedro Aguirre Cerda","Peñaflor","Peñalolén","Pirque","Providencia","Pudahuel","Puente Alto","Quilicura","Quinta Normal","Recoleta","Renca","San Bernardo","San Joaquín","San José de Maipo","San Miguel","San Pedro","San Ramón","Santiago","Talagante","Tiltil","Vitacura","Ñuñoa"],
      TA: ["Alto Hospicio","Camiña","Colchane","Huara","Iquique","Pica","Pozo Almonte"],
      VS: ["Algarrobo","Cabildo","Calera","Calle Larga","Cartagena","Casablanca","Catemu","Concón","El Quisco","El Tabo","Hijuelas","Isla de Pascua","Juan Fernández","La Cruz","La Ligua","Limache","Llaillay","Los Andes","Nogales","Olmué","Panquehue","Papudo","Petorca","Puchuncaví","Putaendo","Quillota","Quilpué","Quintero","Rinconada","San Antonio","San Esteban","San Felipe","Santa María","Santo Domingo","Valparaíso","Villa Alemana","Viña del Mar","Zapallar"]
    };
    var MENSAJES = {
      'razon-social_fact': 'Falta la razón social.',
      rut_fact: 'El RUT no es válido. Escríbelo sin puntos y con guion, por ejemplo 12345678-9.',
      giro_fact: 'Falta el giro.',
      direccion_fact: 'Falta la dirección de facturación.',
      region_fact: 'Elige la región.',
      comuna_fact: 'Elige la comuna.',
      fono_fact: 'Escribe un teléfono de al menos 8 dígitos.',
      email_fact: 'Escribe un correo válido.'
    };

    /* RUT: la misma cuenta del dígito verificador que usaba el Wokiee. */
    function dv(t) { var m = 0, s = 1; for (; t; t = Math.floor(t / 10)) s = (s + t % 10 * (9 - m++ % 6)) % 11; return s ? String(s - 1) : 'k'; }
    function rutValido(v) {
      v = (v || '').replace(/\./g, '').trim();
      if (!/^[0-9]+[-‐][0-9kK]$/.test(v)) return false;
      var p = v.split(/[-‐]/);
      return dv(Number(p[0])) === p[1].toLowerCase();
    }
    function formatoRut(v) {
      var limpio = (v || '').replace(/[^0-9kK]/g, '').toUpperCase();
      return limpio.length < 2 ? limpio : limpio.slice(0, -1) + '-' + limpio.slice(-1);
    }
    function valido(clave, valor) {
      valor = (valor || '').trim();
      if (clave === 'rut_fact') return rutValido(valor);
      if (clave === 'email_fact') return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor);
      if (clave === 'fono_fact') return valor.replace(/\D/g, '').length >= 8;
      return valor !== '';
    }

    var raiz, cfg, carro = null;
    var piezas = { envio: null, recos: null, filas: null, dialogos: [] };
    var dlg = { regalo: null, factura: null };

    function $(el, sel) { return el ? el.querySelector(sel) : null; }
    function dinero(cents) {
      try { return new Intl.NumberFormat('es-CL', { style: 'currency', currency: cfg.moneda || 'CLP', maximumFractionDigits: 0 }).format(cents / 100); }
      catch (e) { return '$' + Math.round(cents / 100); }
    }
    function recorte(t, n) { t = (t || '').trim(); return t.length > n ? t.slice(0, n - 1) + '…' : t; }
    function reducido() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

    /* ── Red ──────────────────────────────────────────────────────────────────── */
    function pedir(url, body) {
      return fetch(url, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || j.status) throw new Error(j.description || j.message || 'No se pudo actualizar el carro.');
          return j;
        });
      });
    }
    /* Todo lo que escribe en el carro va en fila: dos guardados casi juntos no se pisan, y el botón
       de pagar puede esperar a que la fila se vacíe. */
    var cola = Promise.resolve(), pendientes = 0;
    function encolar(fn) {
      pendientes++;
      var p = cola.then(fn);
      cola = p.catch(function () {}).then(function () { pendientes--; });
      return p;
    }
    function guardarAtributos(attrs) {
      return encolar(function () { return pedir('/cart/update.js', { attributes: attrs }); })
        .then(function (c) { carro = c; pintarTodo(); return c; });
    }

    /* Tras agregar o cambiar líneas, Horizon tiene que redibujar el drawer y el globito del carro.
       Se usa el mismo evento que despacha el formulario de producto, con el HTML de la sección que
       devolvió la misma petición. Si el módulo de eventos no carga, se recarga la página. */
    var modEventos = null;
    function avisarHorizon(accion, lineas, respuesta) {
      modEventos = modEventos || import('@shopify/events').catch(function () { return null; });
      return modEventos.then(function (m) {
        var E = m && m.CartLinesUpdateEvent;
        if (!E) { window.location.reload(); return; }
        var diferido = E.createPromise();
        document.dispatchEvent(new E({ action: accion, context: 'cart', lines: lineas, promise: diferido.promise }));
        return pedir('/cart.js').then(function (c) {
          carro = c;
          diferido.resolve({
            cart: E.createCartFromAjaxResponse(c),
            detail: { sections: respuesta && respuesta.sections, items: c.items, itemCount: c.item_count, source: 'algodones-carro-lateral', didError: false }
          });
          pintarTodo();
        });
      });
    }

    /* ── Montaje dentro del drawer ────────────────────────────────────────────── */
    function preparar() {
      raiz = document.querySelector('algodones-carro-lateral');
      if (!raiz) return false;
      try { cfg = JSON.parse(raiz.querySelector('[data-alg-cl="config"]').textContent); } catch (e) { return false; }
      function clonar(nombre) {
        var t = raiz.querySelector('template[data-alg-cl="' + nombre + '"]');
        return t ? t.content.cloneNode(true) : null;
      }
      var f;
      if ((f = clonar('envio'))) piezas.envio = f.firstElementChild;
      if ((f = clonar('recos'))) piezas.recos = f.firstElementChild;
      if ((f = clonar('filas'))) piezas.filas = f.firstElementChild;
      if ((f = clonar('dialogos'))) piezas.dialogos = Array.prototype.slice.call(f.children);
      dlg.regalo = piezas.dialogos.filter(function (d) { return d.id === 'alg-cl-dlg-regalo'; })[0] || null;
      dlg.factura = piezas.dialogos.filter(function (d) { return d.id === 'alg-cl-dlg-factura'; })[0] || null;
      cablearRecos(); cablearFilas(); cablearRegalo(); cablearFactura();
      return true;
    }
    function esNuestro(n) {
      return !!n && (n === piezas.envio || n === piezas.recos || n === piezas.filas || piezas.dialogos.indexOf(n) > -1);
    }
    function dentroNuestro(n) { for (; n; n = n.parentNode) if (esNuestro(n)) return true; return false; }
    function alFinal(padre, el) {
      if (!padre || !el) return;
      if (el.parentNode !== padre || padre.lastElementChild !== el) padre.appendChild(el);
    }
    function quitar(el) { if (el && el.parentNode) el.parentNode.removeChild(el); }

    function montar() {
      var drawer = document.getElementById('cart-drawer');
      var panel = drawer && drawer.querySelector('dialog');
      var inner = drawer && drawer.querySelector('.cart-drawer__inner');
      if (!panel || !inner) return;
      var resumen = inner.querySelector('.cart-drawer__summary');
      if (!resumen) {
        quitar(piezas.envio); quitar(piezas.recos); quitar(piezas.filas);
      } else {
        alFinal(inner.querySelector('.theme-drawer__header'), piezas.envio);
        alFinal(inner.querySelector('.cart-drawer__items'), piezas.recos);
        alFinal(resumen.querySelector('.cart-actions') || resumen.querySelector('.cart-totals'), piezas.filas);
      }
      piezas.dialogos.forEach(function (d) { if (d.parentNode !== panel) panel.appendChild(d); });
    }

    var espera;
    function refrescar() {
      clearTimeout(espera);
      espera = setTimeout(function () {
        pedir('/cart.js').then(function (c) { carro = c; pintarTodo(); }).catch(function () {});
      }, 120);
    }
    var observador = new MutationObserver(function (cambios) {
      var ajeno = cambios.some(function (m) {
        if (dentroNuestro(m.target)) return false;
        if (m.type === 'characterData') return true;
        var nodos = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
        return nodos.some(function (n) { return !esNuestro(n); });
      });
      montar();
      if (ajeno) refrescar();
    });

    /* ── 1 · Envío gratis ─────────────────────────────────────────────────────── */
    function pintarEnvio() {
      var el = piezas.envio;
      if (!el || !cfg.umbral) return;
      var total = carro.total_price;
      var falta = Math.max(0, cfg.umbral - total);
      var avance = Math.min(1, total / cfg.umbral);
      var listo = falta === 0;
      el.style.setProperty('--alg-cl-avance', avance.toFixed(4));
      $(el, '[data-alg="envio-barra"]').setAttribute('aria-valuenow', String(Math.round(avance * 100)));
      var texto = $(el, '[data-alg="envio-texto"]');
      texto.textContent = '';
      if (listo) {
        texto.textContent = cfg.textoListo;
      } else {
        var partes = (cfg.textoFalta || '').split('[monto]');
        var monto = document.createElement('strong');
        monto.textContent = dinero(falta);
        texto.append(partes[0], monto, partes.slice(1).join(''));
      }
      el.classList.toggle('is-listo', listo);
    }

    /* ── 2 · Recomendados ─────────────────────────────────────────────────────── */
    function pintarRecos() {
      var el = piezas.recos;
      if (!el) return;
      var enCarro = {};
      carro.items.forEach(function (i) { enCarro[i.product_id] = true; });
      var visibles = 0;
      el.querySelectorAll('.alg-cl-reco').forEach(function (li) {
        var ocultar = !!enCarro[li.dataset.producto] && li.dataset.agregado !== '1';
        li.hidden = ocultar;
        if (!ocultar) visibles++;
      });
      el.hidden = visibles === 0;
      flechas();
    }
    function flechas() {
      var el = piezas.recos, pista = $(el, '[data-alg="recos-pista"]');
      if (!pista) return;
      var caja = $(el, '.alg-cl-recos__flechas');
      var max = pista.scrollWidth - pista.clientWidth;
      caja.hidden = max <= 4;
      $(el, '[data-alg="recos-prev"]').disabled = pista.scrollLeft <= 4;
      $(el, '[data-alg="recos-next"]').disabled = pista.scrollLeft >= max - 4;
    }
    function cablearRecos() {
      var el = piezas.recos;
      if (!el) return;
      var pista = $(el, '[data-alg="recos-pista"]');
      pista.addEventListener('scroll', flechas, { passive: true });
      window.addEventListener('resize', flechas);
      el.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-alg="reco-variante"]');
        if (!sel) return;
        var li = sel.closest('.alg-cl-reco');
        $(li, '[data-alg="reco-precio"]').textContent = sel.selectedOptions[0].dataset.precio;
      });
      el.addEventListener('click', function (e) {
        var mover = e.target.closest('[data-alg="recos-prev"], [data-alg="recos-next"]');
        if (mover) {
          var tarjeta = $(pista, '.alg-cl-reco:not([hidden])');
          var paso = tarjeta ? tarjeta.getBoundingClientRect().width + 10 : pista.clientWidth * 0.8;
          pista.scrollBy({ left: mover.dataset.alg === 'recos-next' ? paso : -paso, behavior: reducido() ? 'auto' : 'smooth' });
          return;
        }
        var btn = e.target.closest('[data-alg="reco-agregar"]');
        if (btn && btn.getAttribute('aria-busy') !== 'true') agregarReco(btn);
      });
    }
    function agregarReco(btn) {
      var li = btn.closest('.alg-cl-reco');
      var sel = $(li, '[data-alg="reco-variante"]');
      var id = Number(sel ? sel.value : btn.dataset.variante);
      var texto = $(btn, '[data-alg="reco-agregar-texto"]');
      btn.setAttribute('aria-busy', 'true');
      encolar(function () { return pedir('/cart/add.js', { items: [{ id: id, quantity: 1 }], sections: SECCION }); })
        .then(function (r) {
          li.dataset.agregado = '1';
          btn.classList.add('is-listo');
          texto.textContent = 'Agregado ✓';
          return avisarHorizon('add', [{ merchandiseId: String(id), quantity: 1 }], r);
        })
        .then(function () {
          setTimeout(function () {
            delete li.dataset.agregado;
            btn.classList.remove('is-listo');
            texto.textContent = 'Agregar';
            if (carro) pintarRecos();
          }, 1400);
        })
        .catch(function (err) {
          texto.textContent = 'Sin stock';
          setTimeout(function () { texto.textContent = 'Agregar'; }, 2000);
          console.warn('[algodones-carro-lateral]', err);
        })
        .finally(function () { btn.removeAttribute('aria-busy'); });
    }

    /* ── Popups ───────────────────────────────────────────────────────────────── */
    function abrir(d, alAbrir) {
      if (!d) return;
      montar();
      if (!d.open) d.showModal();
      if (alAbrir) alAbrir();
    }
    function cerrar(d) { if (d && d.open) d.close(); }
    /* Tras guardar, el desplegable queda abierto: el cliente ve ahí lo que guardó. */
    function abrirFila(n) { var f = $(piezas.filas, '[data-alg="' + n + '"]'); if (f) f.open = true; }
    function cablearDialogo(d, alCerrar) {
      if (!d) return;
      /* Escape cierra solo el popup: sin preventDefault, el drawer también se cerraría. */
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); cerrar(d); } });
      d.addEventListener('click', function (e) {
        if (e.target === d || e.target.closest('[data-alg="cerrar"]')) cerrar(d);
      });
      d.addEventListener('close', function () { if (alCerrar) alCerrar(); });
    }
    function estado(d, texto, error) {
      var p = $(d, '[data-alg="estado"]');
      p.textContent = texto || '';
      p.classList.toggle('is-error', !!error);
    }
    function ocupado(d, si) {
      var b = $(d, '[data-alg="guardar"]');
      b.disabled = si;
      if (si) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    }

    /* ── 3a · Regalo ──────────────────────────────────────────────────────────── */
    function estadoRegalo() {
      var a = carro.attributes || {};
      var linea = carro.items.filter(function (i) { return i.variant_id === cfg.envoltorio; })[0] || null;
      var modo = a['gift-mode'] === 'pack' ? 'pack' : 'paid';
      return {
        si: a['gift-wrapping'] === 'yes' || !!linea,
        modo: modo, linea: linea, cantidad: linea ? linea.quantity : 1,
        para: a['gift-to'] || '', de: a['gift-from'] || '', nota: a['gift-note'] || ''
      };
    }
    var limpiandoRegalo = false;
    function pintarRegalo() {
      var fila = $(piezas.filas, '[data-alg="fila-regalo"]');
      if (!fila || !cfg.envoltorio) return;
      var st = estadoRegalo();
      /* Si borraron la línea del envoltorio desde el carro, el regalo pagado ya no corre. */
      if (st.si && st.modo === 'paid' && !st.linea && !limpiandoRegalo) {
        limpiandoRegalo = true;
        guardarAtributos(ATTR_REGALO_VACIOS).finally(function () { limpiandoRegalo = false; });
        return;
      }
      $(fila, '[data-alg="regalo-si"]').checked = st.si;
      var valor = $(fila, '[data-alg="regalo-valor"]');
      valor.textContent = !st.si ? 'No' : st.modo === 'pack' ? 'Sí · en pack' : 'Sí · ' + st.cantidad + (st.cantidad === 1 ? ' envoltorio' : ' envoltorios');
      valor.classList.toggle('is-activo', st.si);
      var ficha = $(fila, '[data-alg="regalo-ficha"]');
      ficha.hidden = !st.si;
      if (st.si) {
        var partes = [st.modo === 'pack' ? 'Viene envuelto en el pack' : 'Envoltorio de regalo × ' + st.cantidad];
        if (st.para) partes.push('Para: ' + st.para);
        if (st.de) partes.push('De: ' + st.de);
        if (st.nota) partes.push('«' + recorte(st.nota, 60) + '»');
        $(ficha, '[data-alg="regalo-ficha-texto"]').textContent = partes.join(' · ');
      }
    }
    function cablearFilas() {
      var f = piezas.filas;
      if (!f) return;
      f.addEventListener('change', function (e) {
        var t = e.target;
        if (t.dataset.alg === 'regalo-si') {
          if (t.checked) abrirRegalo();
          else quitarRegalo().catch(function () { t.checked = true; });
        }
        if (t.dataset.alg === 'doc-tipo') {
          if (t.value === 'Yes') abrirFactura(false);
          else guardarAtributos({ Factura: 'No' }).catch(function () {});
        }
      });
      f.addEventListener('click', function (e) {
        if (e.target.closest('[data-alg="regalo-editar"]')) abrirRegalo();
        if (e.target.closest('[data-alg="factura-editar"]')) abrirFactura(false);
      });
    }
    function abrirRegalo() {
      var d = dlg.regalo;
      if (!d || !carro) return;
      var st = estadoRegalo();
      d.querySelector('[data-alg="regalo-modo"][value="' + st.modo + '"]').checked = true;
      $(d, '[data-alg="regalo-cantidad"]').value = st.cantidad;
      $(d, '[data-attr="gift-to"]').value = st.para;
      $(d, '[data-attr="gift-from"]').value = st.de;
      $(d, '[data-attr="gift-note"]').value = st.nota;
      modoRegalo(); cuentaNota(); estado(d, '');
      abrir(d, function () { var r = $(d, '[data-alg="regalo-modo"]:checked'); if (r) r.focus(); });
    }
    function modoRegalo() {
      var d = dlg.regalo;
      $(d, '[data-alg="regalo-cantidad-caja"]').hidden = $(d, '[data-alg="regalo-modo"]:checked').value !== 'paid';
    }
    function cuentaNota() {
      var d = dlg.regalo, t = $(d, '[data-attr="gift-note"]');
      $(d, '[data-alg="cuenta"]').textContent = t.value.length + ' / ' + t.maxLength;
    }
    function cablearRegalo() {
      var d = dlg.regalo;
      if (!d) return;
      cablearDialogo(d, function () { if (carro) pintarRegalo(); });
      d.addEventListener('change', function (e) { if (e.target.dataset.alg === 'regalo-modo') modoRegalo(); });
      d.addEventListener('input', function (e) { if (e.target.dataset.attr === 'gift-note') cuentaNota(); });
      d.addEventListener('click', function (e) {
        var b = e.target.closest('[data-alg="menos"], [data-alg="mas"]');
        if (!b) return;
        var inp = $(d, '[data-alg="regalo-cantidad"]');
        inp.value = Math.min(20, Math.max(1, (parseInt(inp.value, 10) || 1) + (b.dataset.alg === 'mas' ? 1 : -1)));
      });
      $(d, '[data-alg="form-regalo"]').addEventListener('submit', function (e) {
        e.preventDefault();
        guardarRegalo();
      });
    }
    function guardarRegalo() {
      var d = dlg.regalo;
      var modo = $(d, '[data-alg="regalo-modo"]:checked').value;
      var cant = Math.min(20, Math.max(1, parseInt($(d, '[data-alg="regalo-cantidad"]').value, 10) || 1));
      var attrs = {
        'gift-wrapping': 'yes', 'gift-mode': modo, 'gift-wrap-qty': modo === 'paid' ? String(cant) : '',
        'gift-to': $(d, '[data-attr="gift-to"]').value.trim(),
        'gift-from': $(d, '[data-attr="gift-from"]').value.trim(),
        'gift-note': $(d, '[data-attr="gift-note"]').value.trim()
      };
      var st = estadoRegalo();
      var deseada = modo === 'paid' ? cant : 0;
      var actual = st.linea ? st.linea.quantity : 0;
      var trabajo;
      if (deseada === actual) {
        trabajo = guardarAtributos(attrs);
      } else if (actual === 0) {
        trabajo = encolar(function () { return pedir('/cart/add.js', { items: [{ id: cfg.envoltorio, quantity: deseada }], sections: SECCION }); })
          .then(function (r) {
            return encolar(function () { return pedir('/cart/update.js', { attributes: attrs }); })
              .then(function () { return avisarHorizon('add', [{ merchandiseId: String(cfg.envoltorio), quantity: deseada }], r); });
          });
      } else {
        var cambios = {}; cambios[cfg.envoltorio] = deseada;
        trabajo = encolar(function () { return pedir('/cart/update.js', { updates: cambios, attributes: attrs, sections: SECCION }); })
          .then(function (r) { return avisarHorizon(deseada ? 'update' : 'remove', [{ id: st.linea.key, quantity: deseada }], r); });
      }
      ocupado(d, true); estado(d, 'Guardando…');
      trabajo.then(function () { estado(d, ''); cerrar(d); abrirFila('fila-regalo'); })
        .catch(function (err) { estado(d, err.message || 'No se pudo guardar. Inténtalo de nuevo.', true); })
        .finally(function () { ocupado(d, false); });
    }
    function quitarRegalo() {
      var st = estadoRegalo();
      if (!st.linea) return guardarAtributos(ATTR_REGALO_VACIOS);
      var cambios = {}; cambios[cfg.envoltorio] = 0;
      return encolar(function () { return pedir('/cart/update.js', { updates: cambios, attributes: ATTR_REGALO_VACIOS, sections: SECCION }); })
        .then(function (r) { return avisarHorizon('remove', [{ id: st.linea.key, quantity: 0 }], r); });
    }

    /* ── 3b · Boleta o factura ────────────────────────────────────────────────── */
    function pintarDoc() {
      var f = piezas.filas, fila = $(f, '[data-alg="fila-doc"]');
      if (!fila) return;
      var a = carro.attributes || {};
      var esF = a.Factura === 'Yes';
      var abierto = dlg.factura && dlg.factura.open;
      if (!abierto) fila.querySelector('[data-alg="doc-tipo"][value="' + (esF ? 'Yes' : 'No') + '"]').checked = true;
      $(f, '[data-alg="factura-oculto"]').value = esF ? 'Yes' : 'No';
      var valor = $(fila, '[data-alg="doc-valor"]');
      valor.textContent = esF ? 'Factura' : 'Boleta';
      valor.classList.toggle('is-activo', esF);
      var ficha = $(fila, '[data-alg="factura-ficha"]');
      ficha.hidden = !esF;
      if (esF) $(ficha, '[data-alg="factura-ficha-texto"]').textContent = [a['razon-social_fact'], a.rut_fact ? 'RUT ' + a.rut_fact : ''].filter(Boolean).join(' · ') || 'Faltan datos';
    }
    /* BSale necesita el atributo en todos los pedidos: si el carro no lo tiene, se graba «No» una vez. */
    function facturaPorDefecto() {
      if (!cfg.factura || !carro.item_count || (carro.attributes || {}).Factura || window.__algFacturaDefault) return;
      window.__algFacturaDefault = true;
      guardarAtributos({ Factura: 'No' }).catch(function () { window.__algFacturaDefault = false; });
    }
    function camposFactura() { return dlg.factura.querySelectorAll('[data-clave]'); }
    function marcar(el, ok) {
      var err = document.getElementById(el.getAttribute('aria-describedby'));
      el.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (err) { err.hidden = ok; err.textContent = ok ? '' : MENSAJES[el.dataset.clave]; }
    }
    function llenarComunas(conservar) {
      var d = dlg.factura, reg = $(d, '[data-clave="region_fact"]'), sel = $(d, '[data-clave="comuna_fact"]');
      var actual = conservar || '';
      sel.innerHTML = '';
      var vacia = document.createElement('option');
      vacia.value = ''; vacia.textContent = reg.value ? 'Elige la comuna' : 'Primero elige la región';
      sel.appendChild(vacia);
      (COMUNAS[reg.value] || []).forEach(function (c) {
        var o = document.createElement('option');
        o.value = c; o.textContent = c; o.selected = c === actual;
        sel.appendChild(o);
      });
    }
    function validarFactura() {
      var primero = null, n = 0;
      camposFactura().forEach(function (el) {
        var ok = valido(el.dataset.clave, el.value);
        marcar(el, ok);
        if (!ok) { n++; primero = primero || el; }
      });
      var alerta = $(dlg.factura, '[data-alg="alerta"]');
      alerta.hidden = !primero;
      if (primero) {
        alerta.textContent = n === 1 ? 'Falta un dato de la factura. Revisa el campo marcado.' : 'Faltan ' + n + ' datos de la factura. Revisa los campos marcados.';
        primero.focus();
      }
      return !primero;
    }
    function abrirFactura(mostrarErrores) {
      var d = dlg.factura;
      if (!d || !carro) return;
      var a = carro.attributes || {};
      camposFactura().forEach(function (el) {
        if (el.dataset.clave !== 'comuna_fact') el.value = a[el.dataset.clave] || '';
        marcar(el, true);
      });
      llenarComunas(a.comuna_fact || '');
      $(d, '[data-alg="alerta"]').hidden = true;
      estado(d, '');
      abrir(d, function () {
        if (mostrarErrores) validarFactura();
        else { var p = $(d, '[data-clave]'); if (p) p.focus(); }
      });
    }
    function cablearFactura() {
      var d = dlg.factura;
      if (!d) return;
      /* Si se cierra sin guardar, el selector vuelve a lo que diga el carro. */
      cablearDialogo(d, function () { if (carro) pintarDoc(); });
      d.addEventListener('change', function (e) {
        if (e.target.dataset.clave === 'region_fact') { llenarComunas(''); marcar($(d, '[data-clave="comuna_fact"]'), true); }
        if (e.target.getAttribute('aria-invalid') === 'true') marcar(e.target, valido(e.target.dataset.clave, e.target.value));
      });
      d.addEventListener('input', function (e) {
        var t = e.target;
        if (t.dataset.clave === 'rut_fact' && t.selectionStart === t.value.length) {
          var nuevo = formatoRut(t.value);
          if (nuevo !== t.value) t.value = nuevo;
        }
        if (t.getAttribute('aria-invalid') === 'true' && valido(t.dataset.clave, t.value)) marcar(t, true);
      });
      d.addEventListener('focusout', function (e) {
        var t = e.target;
        if (!t.dataset || !t.dataset.clave) return;
        if (t.dataset.clave === 'rut_fact') t.value = formatoRut(t.value);
        if (t.value.trim() !== '' || t.getAttribute('aria-invalid') === 'true') marcar(t, valido(t.dataset.clave, t.value));
      });
      $(d, '[data-alg="form-factura"]').addEventListener('submit', function (e) {
        e.preventDefault();
        if (!validarFactura()) return;
        var attrs = { Factura: 'Yes' };
        camposFactura().forEach(function (el) { attrs[el.dataset.clave] = el.value.trim(); });
        ocupado(d, true); estado(d, 'Guardando…');
        guardarAtributos(attrs)
          .then(function () { estado(d, ''); cerrar(d); abrirFila('fila-doc'); })
          .catch(function (err) { estado(d, err.message || 'No se pudo guardar. Inténtalo de nuevo.', true); })
          .finally(function () { ocupado(d, false); });
      });
    }

    /* ── El botón de pagar del drawer ─────────────────────────────────────────── */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('#cart-drawer [name="checkout"], #cart-drawer #checkout');
      if (!b || b.__algPasa || !cfg) return;
      var a = (carro && carro.attributes) || {};
      if (cfg.factura && dlg.factura && a.Factura === 'Yes' && CLAVES_FACT.some(function (k) { return !valido(k, a[k]); })) {
        e.preventDefault(); e.stopImmediatePropagation();
        abrirFactura(true);
        return;
      }
      /* Si todavía se está guardando algo, se espera y se vuelve a apretar. */
      if (pendientes > 0) {
        e.preventDefault(); e.stopImmediatePropagation();
        b.setAttribute('aria-busy', 'true');
        cola.then(function () {
          b.removeAttribute('aria-busy');
          b.__algPasa = true; b.click(); b.__algPasa = false;
        });
      }
    }, true);

    function pintarTodo() {
      if (!carro) return;
      pintarEnvio(); pintarRecos(); pintarRegalo(); pintarDoc(); facturaPorDefecto();
    }

    function iniciar() {
      if (!preparar()) return;
      montar();
      var drawer = document.getElementById('cart-drawer');
      if (drawer) observador.observe(drawer, { childList: true, subtree: true, characterData: true });
      pedir('/cart.js').then(function (c) { carro = c; pintarTodo(); }).catch(function () {});
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["algodones-categorias"] && !Shopify.designMode) return;
  try {
    
  /* Carrusel de categorías: estado de los bordes y las flechas.
     Sin librería —es un storefront— y sobre el scroll nativo, así el swipe del
     teléfono y las flechas del teclado siguen funcionando sin código extra. */
  (function () {
    function iniciar(pista) {
      var sc = pista.querySelector('[data-alg-cat-scroller]');
      if (!sc || pista.dataset.algListo === '1') return;
      pista.dataset.algListo = '1';

      var prev = pista.querySelector('[data-alg-cat-prev]');
      var next = pista.querySelector('[data-alg-cat-next]');
      var quieto = window.matchMedia('(prefers-reduced-motion: reduce)');

      function estado() {
        var max = sc.scrollWidth - sc.clientWidth;
        pista.classList.toggle('is-scrollable', max > 4);
        pista.classList.toggle('is-inicio', sc.scrollLeft <= 4);
        pista.classList.toggle('is-fin', sc.scrollLeft >= max - 4);
      }
      function mover(dir) {
        sc.scrollBy({
          left: dir * Math.max(sc.clientWidth * 0.8, 160),
          behavior: quieto.matches ? 'auto' : 'smooth'
        });
      }
      if (prev) prev.addEventListener('click', function () { mover(-1); });
      if (next) next.addEventListener('click', function () { mover(1); });
      sc.addEventListener('scroll', estado, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(estado).observe(sc);
      window.addEventListener('resize', estado);
      /* Y otra vez al terminar de cargar: las fuentes y las fotos entran después
         del primer cálculo y pueden cambiar si la pista desborda o no. */
      window.addEventListener('load', estado);
      estado();
    }
    function arrancar() {
      document.querySelectorAll('[data-alg-cat-pista]').forEach(iniciar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arrancar);
    } else {
      arrancar();
    }
    document.addEventListener('shopify:section:load', arrancar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
